module.exports = __webpack_public_path__ + "static/media/back-ground1.b7e4203a.jpeg";